import type { IntrinsicSystemProps, MotionPropsFor } from '@hover/blueprint';
import type { AnimatePresenceProps, TargetAndTransition } from 'framer-motion';
import { matchPath } from 'react-router';

import { customizeRoutes, fullscreenImageRoutes } from '../constants';

export const isCustomizeRoute = (pathname: string) =>
  !!matchPath(pathname, customizeRoutes);

export const isFullscreenImageRoute = (pathname: string) =>
  !!matchPath(pathname, fullscreenImageRoutes);

export interface RouteAnimationProps {
  shouldAnimate: boolean;
  containerProps?: MotionPropsFor<IntrinsicSystemProps<'div'>>;
  mode?: AnimatePresenceProps['mode'];
}

export interface RouteAnimationCustom {
  shouldAnimate: boolean;
  to: string;
  from: string;
}

export const getRouteAnimation = (
  previousPath: string,
  currentPath: string,
): RouteAnimationProps => {
  if (previousPath === currentPath) return { shouldAnimate: false };

  if (isCustomizeRoute(previousPath) && isFullscreenImageRoute(currentPath)) {
    return {
      mode: 'sync',
      shouldAnimate: true,
      containerProps: {
        initial: { opacity: 1 },
        animate: { opacity: 1 },
        transition: { duration: 0 },
      },
    };
  }

  if (isCustomizeRoute(previousPath) && !isCustomizeRoute(currentPath)) {
    return {
      mode: 'wait',
      shouldAnimate: true,
      containerProps: {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
      },
    };
  }

  if (
    isFullscreenImageRoute(previousPath) ||
    isFullscreenImageRoute(currentPath) ||
    isCustomizeRoute(currentPath)
  ) {
    return { shouldAnimate: false };
  }

  return { shouldAnimate: true, mode: 'wait' };
};

export const getRouteExitAnimation = (
  previousPath: string,
  currentPath: string,
): TargetAndTransition => {
  if (isFullscreenImageRoute(previousPath) && isCustomizeRoute(currentPath)) {
    return { opacity: 0 };
  }

  if (isCustomizeRoute(previousPath)) {
    return { opacity: 0 };
  }

  return { opacity: 0, y: 50 };
};
